export default function initTelButtons($) {
  let telBtns = document.querySelectorAll('.btn.btn--tel');
  if(typeof(telBtns) != 'undefined' && telBtns != null) {
    telBtns.forEach((btn) => {
      btn.addEventListener("click", (e) => { 
        if( btn.classList.contains('disabled') ){
          e.preventDefault();
          
          btn.classList.remove('disabled');
          btn.querySelector('.tel').classList.remove('d-none');
          btn.querySelector('.display').classList.add('d-none');
        }else {
          console.log('non')
        }
        // console.log(this);
        // e.classList.removeClass('hide');
      });
    });
  }
}
